import { Debug } from 'js/components/Util/Debug.js';
import { Scope } from 'ts/components/AnalyticsDebugger/Scope';
import { EventNameTab } from 'ts/components/AnalyticsDebugger/EventNameTab';
import { ScopeNameTab } from 'ts/components/AnalyticsDebugger/ScopeNameTab';
import { SettingsTab } from 'ts/components/AnalyticsDebugger/SettingsTab';
import { LogTab } from 'ts/components/AnalyticsDebugger/LogTab';
import { Tab } from 'ts/components/AnalyticsDebugger/Tab';
import 'sass/components/AnalyticsDebugger/index.scss';

class AnalyticsDebugger {
  tabs: Tab[];

  constructor () {
    this.tabs = [];
    this.enable();
  }

  addSideMenu () {
    const sidemenu = document.createElement('div');
    sidemenu.classList.add('Analytics');

    const sidemenuToggles = document.createElement('div');
    sidemenuToggles.classList.add('Analytics-toggles');
    this.tabs.forEach(tab => sidemenuToggles.appendChild(tab.getButton()));

    const sidemenuTabs = document.createElement('div');
    sidemenuTabs.classList.add('Analytics-tabs');

    this.tabs.forEach(tab => sidemenuTabs.appendChild(tab.getTemplate()));

    sidemenu.appendChild(sidemenuToggles);
    sidemenu.appendChild(sidemenuTabs);

    document.body.appendChild(sidemenu);
  }

  addSideMenuToggling(): void {
    const AnalyticsList = document.querySelector('.Analytics');
    const buttons = document.querySelectorAll('.Analytics-toggles--item');
    const htmlTabs = document.querySelectorAll('.Analytics-tabs--item');

    for (let i = 0; i < buttons.length; i++) {
      const button = buttons[i];
      button.addEventListener('click', (evt: Event) => {
        const target: HTMLElement = <HTMLElement> evt.target;
        if (AnalyticsList.classList.contains('show')) {
          if (target.classList.contains('active')) {
            buttons.forEach(
              (button: HTMLElement) => button.classList.remove('active')
            );
            AnalyticsList.classList.toggle('show');
            htmlTabs.forEach(
              (tab: HTMLElement) => tab.classList.remove('active')
            );
          } else {
            buttons.forEach(
              (button: HTMLElement) => button.classList.remove('active')
            );
            htmlTabs.forEach(
              (tab: HTMLElement) => tab.classList.remove('active')
            );
            target.classList.toggle('active');
            htmlTabs[i].classList.add('active');
          }
        } else {
          AnalyticsList.classList.toggle('show');
          target.classList.toggle('active');
          htmlTabs[i].classList.add('active');
        }
      });
    }
  }

  enable() {
    this.tabs = [
      new EventNameTab(),
      new ScopeNameTab(),
      new SettingsTab()
    ];
    this.addSideMenu();
    this.addSideMenuToggling();
  }

  disable() {
    this.tabs = [];
    Debug.disable();
  }
}

export {
  AnalyticsDebugger
}
